module.exports = __webpack_public_path__ + "img/LV3.e2984b89.png";